/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatus } from './entityStatus';
import { NumberType } from './numberType';

export interface OperatorDetailsDto { 
    _id?: string;
    numberType?: NumberType;
    operatorId?: string;
    areaId?: string;
    codePoint?: string;
    rangeStart?: number;
    rangeStop?: number;
    dateCreated?: Date;
    entityStatus?: EntityStatus;
    areaName?: string;
    deleted?: boolean;
}